import { all, call, put, takeEvery } from 'redux-saga/effects'

import IdentityApiService from './IdentityApiService';
import { setErrorLogs } from 'Store/Identity/ErrorLog/ErrorLogAction';
import { GET_ERROR_LOG } from 'Store/Identity/ErrorLog/ErrorLogType';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';



function* getErrorLogsSaga(obj:any):any {
  
    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.Identity,
        endpoint: `errorlog`,
        payload: obj.value
      }   
    try {
        const response = yield call(IdentityApiService.post, API_URL.PostWebApp, payloadData);     
        yield put(setErrorLogs(response));
    } catch (error) {
        yield put(setErrorLogs([]));
    }
}

function* watchOrder() {
    yield takeEvery(GET_ERROR_LOG, getErrorLogsSaga)
   

}

export default function* combinedSaga() {
    yield all([
        watchOrder()
    ])
}
